<template>
  <form @submit.prevent="onFormSubmit">
    <slot
      :on-change="onChange"
      :reset-form="resetForm"
      :form-ref="formRefIdentifier"
    />
  </form>
</template>

<script>
export default {
  name: 'DsForm',
  props: {
    onSubmit: { type: Function },
    formRefs: { type: Object },
  },
  data() {
    return {
      canSubmit: false,
      formRefIdentifier: 'formRef_',
    };
  },
  watch: {
    canSubmit: {
      handler: function (canSubmit) {
        this.$emit('canSubmit', canSubmit);
      },
    },
  },
  mounted() {
    this.checkFormValidity();
  },
  methods: {
    onChange() {
      this.checkFormValidity();
    },
    checkFormValidity() {
      let result = true;

      Object.keys(this.formRefs)
        .filter((key) => key.includes(this.formRefIdentifier))
        .forEach((key) => {
          if (!this.formRefs[key].valid) {
            result = false;
          }
        });

      this.canSubmit = result;
    },
    onFormSubmit() {
      if (this.canSubmit) {
        this.onSubmit();
      }
    },
    resetForm() {
      Object.keys(this.formRefs)
        .filter((key) => key.includes(this.formRefIdentifier))
        .forEach((key) => {
          if (
            this.formRefs[key] !== undefined &&
            this.formRefs[key].resetValue
          ) {
            this.formRefs[key].resetValue();
          }
        });
    },
  },
};
</script>
